(function () {
  const root = document.querySelector('.order-review');
  if (!root) return;

  const apiBaseRaw = (root.dataset.apiBaseUrl || '').trim().replace(/\/$/, '');
  const cardEl = root.querySelector('[data-card]');
  const headingEl = root.querySelector('[data-heading]');
  const eyebrowEl = root.querySelector('[data-eyebrow]');
  const subheadingEl = root.querySelector('[data-subheading]');
  const emojiEl = root.querySelector('[data-emoji]');
  const starsEl = root.querySelector('[data-stars]');
  const formEl = root.querySelector('[data-form]');
  const textareaEl = root.querySelector('[data-comment]');
  const submitBtn = root.querySelector('[data-submit]');
  const ctaEl = root.querySelector('[data-cta]');
  const errorEl = root.querySelector('[data-error]');
  const choiceEl = root.querySelector('[data-choice]');
  const choiceQuestionEl = root.querySelector('[data-choice-question]');
  const choiceSubtextEl = root.querySelector('[data-choice-subtext]');
  const choiceOptionsEl = root.querySelector('[data-choice-options]');
  const fabricBlockEl = root.querySelector('[data-fabric-block]');
  const fabricQuestionEl = root.querySelector('[data-fabric-question]');
  const fabricSubtextEl = root.querySelector('[data-fabric-subtext]');
  const fabricOptionsEl = root.querySelector('[data-fabric-options]');
  const commentQuestionEl = root.querySelector('[data-comment-question]');
  const commentSubtextEl = root.querySelector('[data-comment-subtext]');
  const commentCountEl = root.querySelector('[data-comment-count]');
  const footerNoteEl = root.querySelector('[data-footer-note]');
  const footerNoteTextEl = root.querySelector('[data-footer-note-text]');

  const homeUrl = (root.dataset.homeUrl || '').trim() || 'https://slay.fashion';

  // Promise for the initial rating POST. The UI renders immediately and this
  // saves in the background; later PATCH calls await it so the review row exists.
  let ratingSaved = null;

  // Parse URL params, with a fallback for the case where Shopify order names
  // contain a literal `#` (e.g. "#SLAY-174222"). The `#` ends the URL search
  // string and shoves the rest into location.hash — we recover by reading the
  // hash and stitching the order name back together.
  function parseLinkParams() {
    const search = new URLSearchParams(window.location.search);
    const out = {
      o: search.get('o') || '',
      n: search.get('n') || '',
      s: search.get('s') || '',
      r: search.get('r') || '',
    };

    if (!out.o && window.location.hash) {
      const hashBody = window.location.hash.slice(1);
      const [firstToken, ...rest] = hashBody.split('&');
      if (firstToken && !firstToken.includes('=')) {
        out.o = '#' + firstToken;
      }
      if (rest.length) {
        const hashParams = new URLSearchParams(rest.join('&'));
        if (!out.n) out.n = hashParams.get('n') || '';
        if (!out.s) out.s = hashParams.get('s') || '';
        if (!out.r) out.r = hashParams.get('r') || '';
      }
    }
    return out;
  }

  const linkParams = parseLinkParams();
  const order_name = linkParams.o.trim();
  const first_name = linkParams.n.trim();
  const source = linkParams.s.trim().toUpperCase();
  let rating = parseInt(linkParams.r, 10); // actual rating saved to DB (1–5); editable at the top

  // Sources that get the guided fit + fabric + comment flow (all on one screen).
  const GUIDED_SOURCES = new Set(['WHATSAPP_15D', 'WHATSAPP_2D', 'EMAIL']);

  const VALID_SOURCES = new Set([
    'WHATSAPP_2D', 'WHATSAPP_15D', 'WHATSAPP_DELIVERED', 'EMAIL', 'CALL', 'JUDGE_ME',
  ]);

  // Rating-specific copy + visual variant. `variant` becomes data-rating-variant
  // on the root, which the CSS uses to swap color schemes.
  const COPY = {
    5: {
      variant: 'positive',
      heading: 'Glad you liked it, __NAME__!',
      subheading: "Help us know what worked — your reply helps other shoppers find the right fit.",
      placeholder: 'What did you love most? (fit, fabric, design…)',
      submit: 'Send feedback',
      doneHeading: "We're glad you loved it.",
      doneMessage: 'Your feedback means a lot to us and helps other shoppers too.',
      doneCta: 'Continue Shopping',
    },
    3: {
      variant: 'neutral',
      heading: 'Thanks for the feedback, __NAME__.',
      subheading: "We'd love to do better — was it the fit, the fabric, or something else?",
      placeholder: 'Tell us what we could improve',
      submit: 'Send feedback',
      doneHeading: 'We appreciate your honest feedback.',
      doneMessage: "We'll use it to make your next experience even better.",
      doneCta: 'Continue Shopping',
    },
    1: {
      variant: 'negative',
      heading: "We're really sorry, __NAME__.",
      subheading: "This isn't the experience we wanted for you. What was the main issue?",
      placeholder: 'Tell us what went wrong — we want to make it right',
      submit: 'Send feedback',
      doneHeading: "We'll make it right.",
      doneMessage: 'Your feedback helps us improve and serve you better.',
      doneCta: 'Continue Shopping',
    },
  };

  // Single, non-emoji checkmark used for the done-screen badge across every
  // rating — simpler and consistent instead of a rating-specific emoji.
  const DONE_CHECK_ICON = '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 13 9.5 18.5 20 6"/></svg>';

  // The rating drives what gets SAVED, but EMAIL (1–5 scale) always shows the
  // neutral (3) screens — copy, colour, badges, done page. Any rating without
  // its own COPY entry (e.g. 2 or 4) also falls back to the neutral screen.
  let uiRating = (source === 'EMAIL' || !COPY[rating]) ? 3 : rating;

  // Guided fit/fabric questions — WhatsApp 15D + EMAIL only. Same for every
  // rating (1/3/5) so the data stays consistent and comparable.
  const GUIDED_INTRO = 'Just a few more questions to help us improve.';
  const GUIDED_FIT = {
    q: "How's the fit?",
    subtext: 'Help us understand how this shirt fit you.',
    options: [
      { label: 'Felt slightly tight', icon: 'tight' },
      { label: 'Perfect fit', icon: 'perfect' },
      { label: 'Felt slightly loose', icon: 'loose' },
    ],
  };
  const GUIDED_FABRIC = {
    question: 'How would you rate the fabric quality?',
    subtext: 'Tell us about material, comfort and quality.',
    // stored descriptor per star (consistent scale) — saved as fabric_feedback
    keywords: { 1: 'Very poor', 2: 'Poor', 3: 'Average', 4: 'Good', 5: 'Excellent' },
    // displayed labels under the two ends of the star row
    endLow: 'Below expectation',
    endHigh: 'Above expectation',
  };
  const COMMENT_QUESTION = 'Tell us more';
  const COMMENT_SUBTEXT = 'What could we improve, or what did you love?';
  const COMMENT_MAX_LEN = 300;
  const FOOTER_NOTE = 'Your feedback helps us make better shirts, for you.';

  // Simple line-art t-shirt used on the fit cards, plus inward/outward arrows
  // to signal tight vs. loose. A checkmark badge overlays the selected card.
  const FIT_SHIRT_ICON = '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3.5 L4 7 L6.3 10 L8 8.6 V20.5 H16 V8.6 L17.7 10 L20 7 L16 3.5 C16 5.2 14.2 6.3 12 6.3 C9.8 6.3 8 5.2 8 3.5 Z"/></svg>';
  const FIT_ARROW_RIGHT = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="17" y2="12"/><polyline points="12 7 17 12 12 17"/></svg>';
  const FIT_ARROW_LEFT = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="12" x2="7" y2="12"/><polyline points="12 7 7 12 12 17"/></svg>';
  const FIT_CHECK_ICON = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 12.5 9.5 18 20 6"/></svg>';

  function fitIconHTML(iconType) {
    const shirtWithBadge = `<span class="order-review__fit-shirt-wrap">${FIT_SHIRT_ICON}<span class="order-review__fit-check">${FIT_CHECK_ICON}</span></span>`;
    if (iconType === 'tight') {
      return `<span class="order-review__fit-arrow">${FIT_ARROW_RIGHT}</span>${shirtWithBadge}<span class="order-review__fit-arrow">${FIT_ARROW_LEFT}</span>`;
    }
    if (iconType === 'loose') {
      return `<span class="order-review__fit-arrow">${FIT_ARROW_LEFT}</span>${shirtWithBadge}<span class="order-review__fit-arrow">${FIT_ARROW_RIGHT}</span>`;
    }
    return shirtWithBadge;
  }

  // Answers picked in the fit / fabric sections — only sent once the customer
  // submits the comment (or skips), since everything now lives on one screen.
  let fitValue = null;
  let fabricValue = null;
  let fabricKeyword = null;

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  // Fire-and-forget save — PATCHes any subset of { fit, fabric_rating, fabric, comment }.
  // Used when the customer skips without leaving a comment, so prior answers still persist.
  async function savePatch(fields) {
    if (ratingSaved) { try { await ratingSaved; } catch (e) {} } // ensure the row exists
    try {
      const res = await fetch(`${apiBaseRaw}/api/reviews/comment`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_name, first_name, source, ...fields }),
      });
      return res.ok;
    } catch (e) {
      return false;
    }
  }

  function renderStars(value) {
    if (!starsEl) return;
    let s = '';
    for (let i = 1; i <= 5; i++) s += i <= value ? '★' : '☆';
    starsEl.textContent = s;
    starsEl.hidden = false;
  }

  // Editable star rating shown at the top — the prefilled rating from the link,
  // which the customer can tap to change before continuing.
  function renderEditableStars() {
    if (!starsEl) return;
    starsEl.innerHTML = '';
    starsEl.hidden = false;
    const btns = [];
    const paint = (n) => btns.forEach((b, i) => { b.textContent = i < n ? '★' : '☆'; });
    for (let i = 1; i <= 5; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'order-review__rating-star';
      b.setAttribute('aria-label', i + ' star');
      b.addEventListener('mouseenter', () => paint(i));
      b.addEventListener('click', () => {
        if (i !== rating) { rating = i; onRatingChanged(); }
        paint(rating);
      });
      btns.push(b);
      starsEl.appendChild(b);
    }
    starsEl.addEventListener('mouseleave', () => paint(rating));
    paint(rating);
  }

  // Called when the customer changes the prefilled rating.
  function onRatingChanged() {
    uiRating = (source === 'EMAIL' || !COPY[rating]) ? 3 : rating;
    const copy = COPY[uiRating];
    if (copy) applyVariant(copy.variant);
    saveRating(); // re-save the updated rating in the background
  }

  function fillName(text) {
    return (text || '').replace('__NAME__', first_name || '');
  }

  function applyVariant(variant) {
    if (cardEl) cardEl.setAttribute('data-rating-variant', variant);
    root.setAttribute('data-rating-variant', variant);
  }

  function showThanksState() {
    const copy = COPY[uiRating];
    if (!copy) return;

    applyVariant(copy.variant);
    renderStars(rating);

    if (headingEl) headingEl.textContent = fillName(copy.heading);
    if (subheadingEl) {
      subheadingEl.textContent = copy.subheading;
      subheadingEl.hidden = false;
    }
    if (textareaEl) textareaEl.placeholder = copy.placeholder;
    if (submitBtn) submitBtn.textContent = copy.submit;

    wireSubmitToggle();
    formEl.hidden = false;
  }

  // Keep "Send feedback" inactive until the customer types something.
  // "No thanks" stays enabled so they can always decline.
  let submitToggleWired = false;
  function wireSubmitToggle() {
    if (!submitBtn || !textareaEl) return;
    const toggle = () => { submitBtn.disabled = textareaEl.value.trim().length === 0; };
    if (!submitToggleWired) {
      textareaEl.addEventListener('input', toggle);
      submitToggleWired = true;
    }
    toggle(); // start disabled (textarea empty)
  }

  // ---- Guided flow (WhatsApp 15D / EMAIL): fit + fabric + comment, all on one screen ----

  function renderFitBlock() {
    if (choiceQuestionEl) { choiceQuestionEl.textContent = GUIDED_FIT.q; choiceQuestionEl.hidden = false; }
    if (choiceSubtextEl) { choiceSubtextEl.textContent = GUIDED_FIT.subtext; choiceSubtextEl.hidden = false; }
    if (!choiceOptionsEl) return;
    choiceOptionsEl.innerHTML = '';
    choiceOptionsEl.classList.add('order-review__fit-grid');
    GUIDED_FIT.options.forEach((opt) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'order-review__fit-card';
      btn.innerHTML = `<span class="order-review__fit-icon-row">${fitIconHTML(opt.icon)}</span><span class="order-review__fit-label">${opt.label}</span>`;
      btn.addEventListener('click', () => {
        choiceOptionsEl.querySelectorAll('.order-review__fit-card').forEach((b) => { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        fitValue = opt.label;
        savePatch({ fit: fitValue }); // save immediately so a mid-flow drop-off keeps this answer
      });
      choiceOptionsEl.appendChild(btn);
    });
    if (choiceEl) choiceEl.hidden = false;
  }

  // Fabric section: a 1–5 star rating (variant colour, cumulative fill on tap)
  // with static end-labels. Tapping a star saves immediately (fire-and-forget)
  // and records the answer locally — nothing advances since every question
  // is already visible.
  function renderFabricBlock() {
    if (fabricQuestionEl) { fabricQuestionEl.textContent = GUIDED_FABRIC.question; fabricQuestionEl.hidden = false; }
    if (fabricSubtextEl) { fabricSubtextEl.textContent = GUIDED_FABRIC.subtext; fabricSubtextEl.hidden = false; }
    if (!fabricOptionsEl) return;
    fabricOptionsEl.innerHTML = '';

    // All 5 stars are equal-width flex children, so `space-between` puts them
    // at truly even intervals. The end-labels live in a SEPARATE row below —
    // putting them inside the star row (under star 1 / star 5) made those two
    // columns wider than the middle ones and threw off the star spacing.
    const row = document.createElement('div');
    row.className = 'order-review__stars-input';

    const starEls = [];
    function paint(n) {
      starEls.forEach((b, idx) => { b.textContent = idx < n ? '★' : '☆'; });
    }
    for (let i = 1; i <= 5; i++) {
      const star = document.createElement('button');
      star.type = 'button';
      star.className = 'order-review__star-btn';
      star.textContent = '☆';
      star.setAttribute('aria-label', i + ' star — ' + GUIDED_FABRIC.keywords[i]);
      star.addEventListener('mouseenter', () => paint(i));
      star.addEventListener('click', () => {
        fabricValue = i;
        fabricKeyword = GUIDED_FABRIC.keywords[i];
        paint(i);
        savePatch({ fabric_rating: fabricValue, fabric: fabricKeyword }); // save immediately, same as fit
      });
      starEls.push(star);
      row.appendChild(star);
    }
    row.addEventListener('mouseleave', () => paint(fabricValue || 0));

    fabricOptionsEl.appendChild(row);

    const endsRow = document.createElement('div');
    endsRow.className = 'order-review__star-ends';
    const lblLow = document.createElement('span');
    lblLow.textContent = GUIDED_FABRIC.endLow;
    const lblHigh = document.createElement('span');
    lblHigh.textContent = GUIDED_FABRIC.endHigh;
    endsRow.appendChild(lblLow);
    endsRow.appendChild(lblHigh);
    fabricOptionsEl.appendChild(endsRow);

    if (fabricBlockEl) fabricBlockEl.hidden = false;
  }

  // Comment is optional in the single-screen layout — the submit button stays
  // enabled from the start (unlike the single-question flow's wireSubmitToggle).
  function renderCommentBlock(copy) {
    if (commentQuestionEl) {
      commentQuestionEl.textContent = COMMENT_QUESTION;
      commentQuestionEl.hidden = false;
    }
    if (commentSubtextEl) { commentSubtextEl.textContent = COMMENT_SUBTEXT; commentSubtextEl.hidden = false; }
    if (textareaEl && commentCountEl) {
      const updateCount = () => { commentCountEl.textContent = `${textareaEl.value.length}/${COMMENT_MAX_LEN}`; };
      textareaEl.addEventListener('input', updateCount);
      updateCount();
    }
    if (submitBtn) { submitBtn.textContent = copy.submit; submitBtn.disabled = false; }
    if (formEl) formEl.hidden = false;
  }

  function startGuidedFlow() {
    const copy = COPY[uiRating];
    if (!copy) { showThanksState(); return; }

    applyVariant(copy.variant);
    if (cardEl) cardEl.classList.add('is-guided');
    renderEditableStars(); // prefilled rating the customer can tap to change
    if (headingEl) headingEl.textContent = fillName('Thanks for your rating, __NAME__.');
    if (subheadingEl) {
      subheadingEl.textContent = GUIDED_INTRO;
      subheadingEl.hidden = false;
    }

    renderFitBlock();
    renderFabricBlock();
    renderCommentBlock(copy);

    if (footerNoteTextEl) footerNoteTextEl.textContent = FOOTER_NOTE;
    if (footerNoteEl) footerNoteEl.hidden = false;
  }

  function showDoneState() {
    const copy = COPY[uiRating] || {};
    if (cardEl) cardEl.classList.add('is-done');

    // Circular checkmark badge — same icon for every rating.
    if (emojiEl) {
      emojiEl.innerHTML = DONE_CHECK_ICON;
      emojiEl.className = 'order-review__emoji order-review__emoji--badge';
      emojiEl.hidden = false;
    }
    if (starsEl) starsEl.hidden = true;            // no stars on the thank-you screen
    if (eyebrowEl) {
      eyebrowEl.textContent = 'Thank you!';
      eyebrowEl.hidden = false;
    }
    if (headingEl) {
      headingEl.textContent = copy.doneHeading || root.dataset.headingDone || 'Got it — thanks!';
    }
    if (subheadingEl) {
      subheadingEl.textContent = copy.doneMessage || '';
      subheadingEl.hidden = !copy.doneMessage;
    }
    if (formEl) formEl.hidden = true;
    if (choiceEl) choiceEl.hidden = true;
    if (fabricBlockEl) fabricBlockEl.hidden = true;
    if (footerNoteEl) footerNoteEl.hidden = true;
    if (ctaEl) {
      ctaEl.href = homeUrl;
      ctaEl.textContent = copy.doneCta || 'Continue Shopping';
      ctaEl.hidden = false;
    }
  }

  function disableForm() {
    if (!formEl) return;
    formEl.querySelectorAll('button, textarea').forEach((el) => { el.disabled = true; });
  }
  function enableForm() {
    if (!formEl) return;
    formEl.querySelectorAll('button, textarea').forEach((el) => { el.disabled = false; });
  }

  // Local guard before hitting the API.
  if (!apiBaseRaw) {
    if (headingEl) headingEl.textContent = 'Configuration error';
    showError('API base URL is not configured. Set it in the theme editor.');
    return;
  }
  if (!order_name || !first_name || !VALID_SOURCES.has(source) || !(rating >= 1 && rating <= 5)) {
    if (headingEl) headingEl.textContent = 'This link looks invalid.';
    showError('Please use the link from your message.');
    return;
  }

  // Fire the rating POST in the background — do NOT block the UI on it.
  function saveRating() {
    ratingSaved = fetch(`${apiBaseRaw}/api/reviews/from-store`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_name, first_name, source, rating }),
    }).then((res) => res.ok).catch(() => false);
    return ratingSaved;
  }

  async function submitComment(fields) {
    disableForm();
    if (ratingSaved) { try { await ratingSaved; } catch (e) {} } // ensure the row exists
    try {
      const res = await fetch(`${apiBaseRaw}/api/reviews/comment`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_name, first_name, source, ...fields }),
      });
      if (!res.ok) throw new Error('save_comment_failed');
      showDoneState();
    } catch (e) {
      enableForm();
      showError('Could not save your comment. Please try again.');
    }
  }

  if (formEl) {
    formEl.addEventListener('submit', (ev) => {
      ev.preventDefault();
      if (errorEl) errorEl.hidden = true;
      const comment = (textareaEl?.value || '').trim();
      // Fit/fabric (guided flow) are already saved incrementally as they're
      // picked. Comment is optional here — if it's empty there's nothing
      // left to save, so just show the thank-you screen without an API call.
      if (!comment) { showDoneState(); return; }
      submitComment({ comment });
    });
  }

  // Render the feedback screen immediately, then save the rating in the background.
  // The customer no longer waits on the network before seeing the questions.
  if (GUIDED_SOURCES.has(source)) startGuidedFlow();
  else showThanksState();
  saveRating();
})();
